import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subject } from "rxjs/internal/Subject";
import { UsersFeatureService } from "../services/users-feature.services";
import { map, withLatestFrom } from "rxjs/operators";
import { Observable, Subscription } from "rxjs/index";
import { FeatureViewItem } from "../types/feature-view-item";
import { UserSelectors } from "../../user/state/user.selectors";
import { UserAction } from "../../user/state/user.action";
import { FeaturePermission } from "../../core/model/user.model";

@Component({
  selector: "users-feature-modal",
  templateUrl: "users-feature-modal.component.html",
  styleUrls: ["users-feature-modal.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class UsersFeatureModalComponent implements OnInit, OnDestroy {
  templateModelImageVariable: string;
  displayCopy: boolean;
  cols: { field: string; header: string; width: string }[];
  onClose: Subject<{ isConfirmed: boolean; features: FeatureViewItem[] }>;
  mappedFeatures$: Observable<FeatureViewItem[]>;
  featuresToUpdate: FeatureViewItem[];

  _sub: Subscription = new Subscription();

  constructor(
    private usersFeatureService: UsersFeatureService,
    private modalRef: BsModalRef,
    private modalService: BsModalService,
    private userSelector: UserSelectors,
    private store: Store
  ) {
    this.displayCopy = false;
  }

  ngOnInit(): void {
    this.initializeFeatureModal();

    this.mappedFeatures$ = this.usersFeatureService
      .getPermissionTypeFeatures()
      .pipe(
        withLatestFrom(this.userSelector.selectSelectedUserFeatures()),
        map(([featureServiceResponse, selectedUserFeatures]) => {
          return featureServiceResponse.permissions.map<FeatureViewItem>(
            (item) => {
              const hasFeatureId = Boolean(
                selectedUserFeatures.find(
                  (permission) => permission.permissionId === item.permissionId
                )
              );
              const feature = {
                id: item.permissionId,
                name: item.permissionName,
                key: item.permissionKey,
                status: hasFeatureId,
              };
              if (hasFeatureId) {
                this.addFeatureToUpdate(feature);
              }
              return feature;
            }
          );
        })
      );
  }

  ngOnDestroy(): void {
    this._sub.unsubscribe();
  }

  closeDialog(): void {
    this.modalRef.hide();
  }

  update(): void {
    this.modalRef.hide();
    this.onClose.next({ isConfirmed: true, features: this.featuresToUpdate });
    const featuresMapped = this.featuresToUpdate.map<FeaturePermission>(
      (feature) => {
        return { permissionId: feature.id, permissionKey: feature.key };
      }
    );
    this.store.dispatch(
      UserAction.setUserFeatures({ features: featuresMapped })
    );
  }

  onToggleFeature(event: boolean, feature: FeatureViewItem): void {
    console.log(`Feature KEY: ${feature.key}, Turned -> ${event}`);
    if (event) {
      this.addFeatureToUpdate(feature);
    } else {
      this.removeFeatureToUpdate(feature);
    }
  }

  private initializeFeatureModal(): void {
    this.onClose = new Subject();
    this.featuresToUpdate = [];
    this.cols = [
      { field: "name", header: "Name", width: "35%" },
      { field: "key", header: "Key", width: "35%" },
      { field: "id", header: "Id", width: "15%" },
      { field: "status", header: "", width: "15%" },
    ];
  }

  private addFeatureToUpdate(featureToAdd: FeatureViewItem) {
    this.featuresToUpdate.push(featureToAdd);
  }

  private removeFeatureToUpdate(featureToRemove: FeatureViewItem) {
    this.featuresToUpdate = this.featuresToUpdate.filter(
      (feature) => feature.id !== featureToRemove.id
    );
  }
}
